<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div><p>test</p></div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      form: {
        username: '',
        password: ''
      },
      requestCount: 0,
      cooldoownInterval: null,
      coolDownTimeRemain: 0,
      tempDisableLogin: false
    }
  },
  computed: {
    ...mapState(['currentUser', 'status']),
    coolDownTime () {
      return ((this.requestCount > 5 ? this.requestCount - 5 : this.requestCount) * 10)
    }
  },
  methods: {
    ...mapActions(['signIn']),
    handleLogin () {
      if (!this.tempDisableLogin) {
        if (this.requestCount < 5) {
          this.requestCount += 1
          this.signIn({
            credential: {
              username: this.form.username,
              password: this.form.password,
              type: 'admin',
            },
            vm: this
          })
        } else if (this.requestCount >= 5) {
          this.tempDisableLogin = true
          this.requestCount += 1
          this.coolDownTimeRemain = this.coolDownTime

          this.cooldoownInterval = setInterval(() => {
            if (this.coolDownTimeRemain === 0) {
              this.requestCount = 0
              this.tempDisableLogin = false
              clearInterval(this.cooldownInterval)
            } else {
              Math.max(this.coolDownTimeRemain -= 1, 0)
            }
          }, 1000)
        }
      }
    }
  },
  watch: {
    status: {
      handler(res){
        if(res.success !== null){
          this.$vs.notify({...res.success})
        }else if(res.error !== null){
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    }
  },
}
</script>

<style lang="scss">
</style>
